export default "__VITE_ASSET__CKl46rsK__"